import { Component, AfterViewInit, OnDestroy, Input } from '@angular/core'
import { InsaService } from '../../../insa-services'
//import { ChartModel } from '../../../insa-models/chart.model'
import { appStateProvider } from '../../../insa-providers'
import { Router } from '@angular/router'
import { GenericChartsModule } from '../../../insa-custom-scripts'
//import { appConfig } from '../../../../insaweb.config'
//import { GridsterItem } from 'angular-gridster2/dist/gridsterItem.interface';
//import { InsaMainWindowComponent } from '../insa-main-window/insa-main-window.component';
//import { setTimeout } from 'core-js/library/web/timers';

@Component({
    selector: "donut-chart-widget",
    templateUrl: 'mainWindowDonutChart.component.html'
})
export class MainWindowDonutChart implements OnDestroy, AfterViewInit {
    private randomId = Date.now().toString() + Math.ceil((Math.random() * 100000)).toString();
    private donutChartId = "DonutChart" + this.randomId;
    private donutChartWrapperId = "donut-chart-wrapper" + this.randomId;
    private dataForChart = [{ "Description": "First", "Value": 50 }, { "Description": "Second", "Value": 60 }, { "Description": "Third", "Value": 70 }];
    private subscription: any;
    private _chartWidth: number;
    private _chartHeight: number;

    @Input() 
    set chartWidth(chartWidth: number){
        this._chartWidth = chartWidth;
        this.ResizeChart();
    }

    @Input() 
    set chartHeight(chartHeight: number){
        this._chartHeight = chartHeight;
        this.ResizeChart();
    }

    constructor(private _insaService: InsaService, private _appStateProvider: appStateProvider, private _router: Router) {
    }

    ResizeChart() {
        let chart: kendo.dataviz.ui.Chart = $("#" + this.donutChartId).data("kendoChart");
        if (chart != null) {
            chart.options.chartArea = { background: "", width: $("#" + this.donutChartWrapperId).width(), height: $("#" + this.donutChartWrapperId).height() }
            chart.redraw();
        }
        else { console.log("Chart is empty!!"); }
    }

    ngAfterViewInit() {
        GenericChartsModule.KendoInitGenericDonutChart("#" + this.donutChartId, this.dataForChart, "donut", "Value", "Description", "CHART", false, $("#" + this.donutChartWrapperId).width(), $("#" + this.donutChartWrapperId).height(), "", true);
        setTimeout(() => {
            this.ResizeChart()},
             300);
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-main/insa-main-widgets/mainWindowDonutChart.component.ts